import { WithNAFallback } from '@toggle/design-system';
import { getPriceStatus } from '@toggle/helpers';
import React from 'react';

import {
  formatNumberWithUnit,
  formatPercentageNumber,
} from '../../utils/utils';
import * as S from './NumberCell.styles';

interface NumberCellProps {
  value: number;
  percentage?: boolean;
  useFallbackDash?: boolean;
  fallbackTooltip?: string;
  includePercentSign?: boolean;
}

export const NumberCell = ({
  value,
  percentage,
  useFallbackDash,
  fallbackTooltip,
  includePercentSign = true,
}: NumberCellProps) => {
  const formattedValue = percentage
    ? formatPercentageNumber({ value, includePercentSign, addPlus: percentage })
    : formatNumberWithUnit(value);

  return (
    <S.NumberTableValue $status={getPriceStatus(value)}>
      <WithNAFallback
        containerPadding="0 0 0 8px"
        check={formattedValue !== '-'}
        value={formattedValue}
        useFallbackDash={useFallbackDash}
        tooltip={fallbackTooltip}
      />
    </S.NumberTableValue>
  );
};
